module.exports = __webpack_public_path__ + "static/media/sopt15kz.2386152d.pdf";